import React from "react";
import { EonUiWebsiteNavigationColumn, EonUiWebsiteNavigationLogo, EonUiWebsiteNavigationMain } from "@eon-ui/eon-ui-components-react";
import "./header.scss";
import { AuthComponent } from "../auth/AuthComponent";
import LanguageSwitch from "../language-switch/LanguageSwitch";
import { useCombinedStore } from "../../store/headerStore";
import { useTheme } from "@me8eon/themes";
import bayernwerk from "../../assets/image/header-logos/bayernwerk.raw.svg";
import eon from "../../assets/image/header-logos/eon.raw.svg";
import myhelpbayern from "../../assets/image/header-logos/myhelp-bayern.raw.svg";
import myhelp from "../../assets/image/header-logos/myhelp.raw.svg";
import { setActiveRoleIndex } from "@me8eon/msal_authentication";
import { useUserData } from "@me8eon/react_authentication";
import { GenericDropdown } from "@me8eon/generic_dropdown";
import { useTranslation } from "@me8eon/translation";
import { PublicClientApplication } from "@azure/msal-browser";
import { DevModeState, useDevModeState } from "@me8eon/devmode";
import { Icon } from "@me8eon/icons";
import { useNavigate } from "react-router-dom";
import StarBadge from "./StarBadge";

type HeaderProps = {
    orgName: string;
    msalInstance: PublicClientApplication
}
const Header = ({ orgName, msalInstance }: HeaderProps) => {
    const { language, setLanguage, favData } = useCombinedStore();
    const t = useTranslation();

    console.log({ orgName, language, setLanguage, favData });
    const theme = useTheme();
    const userData = useUserData();
    const { loggedIn } = userData;
    const navigate = useNavigate();
    const { value: themeName, header } = theme;
    const { meAtEonLogoUrl, eonLogoUrl } = header;
    const [devMode, setDevMode] = useDevModeState();

    function toggleDevMode() {
        setDevMode(old => old?.selected ? {} as DevModeState : { selected: "hide" });
    }

    const imageMap: any = {
        bayernwerk,
        eon,
        me8bayern: myhelpbayern,
        me8eon: myhelp,
        default_eon: eon,
        default_me8eon: myhelp,
    };

    const roleToggle = (selectedValue: string) => {
        // const index = userData.allRoles.findIndex((role) => role === selectedValue);
        //This uses msal. Even in teams! but in teams this isn't an idea that exists, and I think this will still work as it will have no effect and won't crash
        setActiveRoleIndex(msalInstance, selectedValue);
        window.location.href = "/ai";
    };

    const admin = localStorage.getItem("admin") === "true";
    return (
        <EonUiWebsiteNavigationMain
            slot="main"
            className="me-eon-header"
            data-testid="header"
        >

            <EonUiWebsiteNavigationColumn content-alignment="left">
                <EonUiWebsiteNavigationLogo
                    imageSrc={imageMap[meAtEonLogoUrl] || imageMap.default_me8eon}
                    description="MyHelp"
                    onClick={(e) => {
                        if (window.location.pathname === "/ai") {
                            window.location.href = "/ai";
                        }
                        e.preventDefault();
                        navigate(`/ai`);
                    }}
                    href="#"
                    className="main-logo"
                ></EonUiWebsiteNavigationLogo>
            </EonUiWebsiteNavigationColumn>
            <EonUiWebsiteNavigationColumn content-alignment="right">
                {loggedIn && (
                    <button
                        className="auth-wrapper"
                        onClick={() => navigate(`/about-myhelp?tab=2`)}
                        title={t("whatsnewtt")}
                    >
                        <StarBadge text={t("new")} textColor="#fff" size={32} />
                        <span className="username whatsnew-text"><b>{t("whatsnew")}</b></span>
                    </button>
                )}
                <AuthComponent />
                {userData.allRoles.length > 1 && (
                    <GenericDropdown
                        label={t("switchRole")}
                        icon="change_contract_01"
                        rootId="roles-dropdown"
                        options={userData.allRoles}
                        maxWidth="200px"
                        selectedOps={userData.currentRole}
                        clickHandler={roleToggle}
                    />
                )}
                <LanguageSwitch />
                {admin && loggedIn && <button style={{ border: 0 }} onClick={toggleDevMode}>Dev</button>}

                <div className="eon-logo-wrapper">
                    <EonUiWebsiteNavigationLogo
                        imageSrc={imageMap[eonLogoUrl] || imageMap.eon}
                        description="E.ON Logo"
                    ></EonUiWebsiteNavigationLogo>
                </div>
            </EonUiWebsiteNavigationColumn>
        </EonUiWebsiteNavigationMain>
    );
};
export default Header;
